module.exports = __webpack_public_path__ + "static/media/negative.989c2555.png";